import React from "react";
import { Card, Grid, IconButton, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import SafeHtml from "@egovernments/digit-ui-module-common/src/sharedComponents/SafeHtml";

dayjs.extend(utc);

const InspectionViewseer = ({ inspectionDetails, formData }) => {
  const formatTime = (time) => {
    return time ? dayjs.utc(time).local().format("DD MMM YYYY, hh:mm A") : "N/A";
  };

  return (
    <div
      style={{
        padding: "10px",
        maxWidth: "100%",
        margin: "auto",
        background: "#fff",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
        borderRadius: "8px",
      }}
    >
      <form>
        {/* {inspectionDetails?.map((item, index) => ( */}
        <div className="formContainer" style={{ marginTop: "18px" }}>
          <div className="inspection-Card-bottom">
            <h2 className="inspection-Card-h1">Site Inspection Form</h2>
            <Grid container spacing={2} style={{ display: "flex" }}>
              <Grid item xs={4} style={{ display: "flex" }}>
                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333", display: "flex" }}>
                  Inspection On:
                </Typography>
                <Typography variant="body2" sx={{ color: "#555" }}>
                  {inspectionDetails?.siteInspecionDateArea || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={4} style={{ display: "flex" }}>
                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333", display: "flex" }}>
                  Time From:
                </Typography>
                <Typography variant="body2" sx={{ color: "#555" }}>
                  {/* {inspectionDetails?.siteInspecionTimeForm || "N/A"} */}
                  {/* {
                                        dayjs(inspectionDetails?.siteInspecionTimeForm, "HH:mm", true).isValid()
                                            ? dayjs(inspectionDetails.siteInspecionTimeForm, "HH:mm").format("hh:mm A")
                                            : "N/A"
                                    } */}
                  {/* {dayjs(inspectionDetails?.siteInspecionTimeForm).format("hh:mm A")} */}
                  {formatTime(inspectionDetails?.siteInspecionTimeForm)}
                </Typography>
              </Grid>
              <Grid item xs={4} style={{ display: "flex" }}>
                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333", display: "flex" }}>
                  Time From:
                </Typography>
                <Typography variant="body2" sx={{ color: "#555" }}>
                  {inspectionDetails?.siteInspecionTimeTO || "N/A"}
                  {/* {
                                        dayjs(inspectionDetails?.siteInspecionTimeTO, "HH:mm", true).isValid()
                                            ? dayjs(inspectionDetails.siteInspecionTimeTO, "HH:mm").format("hh:mm A")
                                            : "N/A"
                                    } */}
                  {/* {dayjs(inspectionDetails?.siteInspecionTimeTO, "HH:mm") || "N/A"} */}
                  {/* {dayjs(inspectionDetails?.siteInspecionTimeTO).format("hh:mm A")} */}
                  {formatTime(inspectionDetails?.siteInspecionTimeTO)}
                </Typography>
              </Grid>
              {/* <Grid item xs={4} style={{ display: "flex" }}>
                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333" }}>
                  Inspected On:
                </Typography>
                <Typography variant="body2" sx={{ color: "#555" }}>
                  {inspectionDetails?.siteInspecionDueDateArea || "N/A"}
                </Typography>
              </Grid> */}
              {/* <Grid item xs={6} style={{ display: 'flex' }} >
                                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333" }}>
                                    Application No :
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#555" }}>
                                    {formData?.applicationNo}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{ display: 'flex' }}>
                                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333" }}>
                                    Applicant Name:
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#555" }}>
                                    {formData?.landInfo?.owners?.[0]?.name}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{ display: 'flex' }}>
                                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333" }}>
                                    Applicant Address:
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#555" }}>
                                    {formData?.professionalDetails?.eradress}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{ display: 'flex' }}>
                                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333" }}>
                                    Building Status:
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#555" }}>
                                    {formData?.landInfo?.status}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{ display: 'flex' }}>
                                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333" }}>
                                    Plot Size:
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#555" }}>
                                    {formData?.descriptionOfLand?.landLength} x {formData?.descriptionOfLand?.landWidth}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{ display: 'flex' }}>
                                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333" }}>
                                    Plot Area:
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#555" }}>
                                    {formData?.ownerInformation?.plotArea}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{ display: 'flex' }}>
                                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333" }}>
                                    Khasra No./Plot No:
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#555" }}>
                                    {formData?.descriptionOfLand?.KhasraWithArea?.[0]?.khasraNo}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{ display: 'flex' }} >
                                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333" }}>
                                    Village/Plan Name:
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#555" }}>
                                    {formData?.revenueVillageMohal}
                                </Typography>
                            </Grid> */}
            </Grid>
          </div>
          <div className="inspection-Card-Top">
            <h2 className="inspection-Card-h1">Dimension of each side of property in SqM.</h2>
            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
              <thead>
                <tr style={{ background: "#f2f2f2" }}>
                  <th style={tableHeader}>Description</th>
                  <th style={tableHeader}>As on Plan</th>
                  <th style={tableHeader}>As on Site</th>
                  <th style={tableHeader}>Observation</th>
                  <th style={tableHeader}>Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={tableCell}>a) Front Side</td>
                  <td style={tableCell}>{inspectionDetails?.frontSide?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.frontSide?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.frontSide?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.frontSide?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>b) Rear Side</td>
                  <td style={tableCell}>{inspectionDetails?.rearSide?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.rearSide?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.rearSide?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.rearSide?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>c) Left Side</td>
                  <td style={tableCell}>{inspectionDetails?.leftSide?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.leftSide?.onSite|| "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.leftSide?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.leftSide?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>d) Right Side</td>
                  <td style={tableCell}>{inspectionDetails?.rightSide?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.rightSide?.onSite|| "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.rightSide?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.rightSide?.remarks || "N/A"}</td>
                </tr>
                
                {inspectionDetails?.siteInspecionAnyOtherSide?.length > 0 ? (
                  inspectionDetails.siteInspecionAnyOtherSide.map((item, index) => (
                    <tr key={index}>
                      <td style={tableCell}>e) Any other side {index + 1}</td>
                      <td style={tableCell}>{item.sideName || "N/A"}</td>
                      <td style={tableCell}>{item.onsiteMeasurement || "N/A"}</td>
                      <td style={tableCell}>{item.observation || "N/A"}</td>
                      <td style={tableCell}>{item.remarks || "N/A"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td style={tableCell}>e) Any other side</td>
                    <td style={tableCell} colSpan={4}>
                      N/A
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="inspection-Card-Top">
            <h2 className="inspection-Card-h1">Status of Property/Plot</h2>
            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
              <thead>
                <tr style={{ background: "#f2f2f2" }}>
                  <th style={tableHeader}>Description</th>
                  <th style={tableHeader}>As on Plan</th>
                  <th style={tableHeader}>As on Site</th>
                  <th style={tableHeader}>Observation</th>
                  <th style={tableHeader}>Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={tableCell}>Construction Status</td>
                  <td style={tableCell}>{inspectionDetails?.construction?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.construction?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.construction?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.construction?.remarks || "N/A"}</td>
                </tr>
                {/* FOR LOW-RISK */}
                {/* {formData?.riskType === "LOW" && (
                  <tr>
                    <td style={tableCell}>Built</td>
                    <td style={tableCell}>{inspectionDetails?.siteInspecionConstructionStatusRemarks || "N/A"}</td>
                    <td style={tableCell}>{inspectionDetails?.siteInspecionBuilt || "N/A"}</td>
                    <td style={tableCell}>{inspectionDetails?.siteInspectionBuiltObservation || "N/A"}</td>
                    <td style={tableCell}>{inspectionDetails?.siteInspecionBuiltRemarks || "N/A"}</td>
                  </tr>
                )} */}
                {/* High */}
                {(formData?.riskType === "MEDIUM" || formData?.riskType === "HIGH") && (
                  <tr>
                    <td style={tableCell}>Whether construction started</td>
                    <td style={tableCell}>{inspectionDetails?.whetherConstructionStarted?.planOn || "N/A"}</td>
                    <td style={tableCell}>{inspectionDetails?.whetherConstructionStarted?.onSite || "N/A"}</td>
                    <td style={tableCell}>{inspectionDetails?.whetherConstructionStarted?.observation || "N/A"}</td>
                    <td style={tableCell}>{inspectionDetails?.whetherConstructionStarted?.remarks || "N/A"}</td>
                  </tr>
                )}
                <tr>
                  <td style={tableCell}>Demolition Started</td>
                  <td style={tableCell}>{inspectionDetails?.demolitionStarted?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.demolitionStarted?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.demolitionStarted?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.demolitionStarted?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Is Property having extra Land</td>
                  <td style={tableCell}>{inspectionDetails?.getExtraProperty?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.getExtraProperty?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.getExtraProperty?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.getExtraProperty?.remarks|| "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>a) Area of extra land</td>
                  <td style={tableCell}>{inspectionDetails?.areaOfExtraLand?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.areaOfExtraLand?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.areaOfExtraLand?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.areaOfExtraLand?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>b)IS extra land Alloted by DA/UPAVP/SADA</td>
                  <td style={tableCell}>{inspectionDetails?.isExtraLandAllotedBy?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isExtraLandAllotedBy?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isExtraLandAllotedBy?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isExtraLandAllotedBy?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Attached Allotement Letter</td>
                  <td style={tableCell}>{inspectionDetails?.attachedAllotement?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.attachedAllotement?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.attachedAllotement?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.attachedAllotement?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Can a seprate property be created</td>
                  <td style={tableCell}>{inspectionDetails?.separateProperty?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.separateProperty?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.separateProperty?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.separateProperty?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Is extra land is for offer</td>
                  <td style={tableCell}>{inspectionDetails?.isExtraLandOffer?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isExtraLandOffer?.onSite|| "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isExtraLandOffer?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isExtraLandOffer?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Is propoerty affected by the water supply</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByWater?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByWater?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByWater?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByWater?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Is propoerty affected by the sewerage</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedBySewerage?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedBySewerage?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedBySewerage?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedBySewerage?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Is propoerty affected by the Electrical Line</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByElectricity?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByElectricity?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByElectricity?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByElectricity?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Is propoerty affected by the Drainage</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByDrainage?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByDrainage?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByDrainage?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByDrainage?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Is propoerty affected by railway line</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByRailway?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByRailway?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByRailway?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByRailway?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Is propoerty affected by gas pipe line</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByGas?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByGas?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByGas?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByGas?.remarks|| "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Is propoerty affected by any pond/lake or any natural body</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByNaturalBody?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByNaturalBody?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByNaturalBody?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPropertyAffectedByNaturalBody?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Location/key plan shown on drawing matches property</td>
                  <td style={tableCell}>{inspectionDetails?.locationShownOnDrawingMatchesProperty?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.locationShownOnDrawingMatchesProperty?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.locationShownOnDrawingMatchesProperty?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.locationShownOnDrawingMatchesProperty?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Plot boundaries and Area as per registery matches the site</td>
                  <td style={tableCell}>{inspectionDetails?.plotBoundariesandAreaAsPerRegisteryMatchesSite?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.plotBoundariesandAreaAsPerRegisteryMatchesSite?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.plotBoundariesandAreaAsPerRegisteryMatchesSite?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.plotBoundariesandAreaAsPerRegisteryMatchesSite?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Is land of Road widening and green belt falling in the Property</td>
                  <td style={tableCell}>{inspectionDetails?.isLandRoadWideningGgreen?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isLandRoadWideningGgreen?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isLandRoadWideningGgreen?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isLandRoadWideningGgreen?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Width of Approch Road to reach property (in Mtr)</td>
                  <td style={tableCell}>{inspectionDetails?.widthOfApprochRoadToReachProperty?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.widthOfApprochRoadToReachProperty?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.widthOfApprochRoadToReachProperty?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.widthOfApprochRoadToReachProperty?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Is the proposed property in possesion of owner</td>
                  <td style={tableCell}>{inspectionDetails?.isThePropertyPossesionOfOwner?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isThePropertyPossesionOfOwner?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isThePropertyPossesionOfOwner?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isThePropertyPossesionOfOwner?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>Is plot adjoining any government land/government building</td>
                  <td style={tableCell}>{inspectionDetails?.isPlotAdjoiningAnyGovernmentLandBuilding?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPlotAdjoiningAnyGovernmentLandBuilding?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPlotAdjoiningAnyGovernmentLandBuilding?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isPlotAdjoiningAnyGovernmentLandBuilding?.remarks || "N/A"}</td>
                </tr>
                <tr>
                  <td style={tableCell}>
                    Infrastructure facilities such as water supply, sewerage, drainage, electrical supply availbale for property
                  </td>
                  <td style={tableCell}>{inspectionDetails?.infraFacilitiesAvailableForProperty?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.infraFacilitiesAvailableForProperty?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.infraFacilitiesAvailableForProperty?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.infraFacilitiesAvailableForProperty?.remarks || "N/A"}</td>
                </tr>
                {/* <tr>
                  {(formData?.riskType === "MEDIUM" || formData?.riskType === "HIGH") && (
                    <td style={tableCell}>Is proposed plot is affected by by any High-Tension or Low-Tension Power line</td>
                  )}
                  {formData?.riskType === "LOW" && 
                  <td style={tableCell}>Is Notice Under Section 83 or Section 27 or Section 28 issued</td>}
                  <td style={tableCell}>{inspectionDetails?.siteInspecionPowerline || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isProposedPlotIsAffectedByPowerLine || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.siteInspectionAffectedPowerObservation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.isProposedPlotIsAffectedByPowerLineRemarks || "N/A"}</td>
                </tr> */}
                <tr>
                  <td style={tableCell}>Does you property lies in the vicinity of the protected monumentals of Heritage Destination</td>
                  <td style={tableCell}>{inspectionDetails?.IsPropertyLiesInVicinityOfHeritageDestination?.planOn || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.IsPropertyLiesInVicinityOfHeritageDestination?.onSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.IsPropertyLiesInVicinityOfHeritageDestination?.observation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.IsPropertyLiesInVicinityOfHeritageDestination?.remarks || "N/A"}</td>
                </tr>
                {/* <tr>
                  <td style={tableCell}>Property shortage distance of Heritage destination (in Mtre)</td>
                  <td style={tableCell}>{inspectionDetails?.siteInspecionPropertyShortage || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.propertyShortage || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.siteInspectionShortDistHeritageObservation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.propertyShortageRemarks || "N/A"}</td>
                </tr> */}
                {/* <tr>
                  {(formData?.riskType === "MEDIUM" || formData?.riskType === "HIGH") && (
                    <td style={tableCell}>Any Other Detail Remark Proposed Site</td>
                  )}
                  {formData?.riskType === "LOW" && <td style={tableCell}>Is Notice Under Section 82 or Section 27 or Section 28 issued</td>}
                  <td style={tableCell}>{inspectionDetails?.siteInspecionAnyOtheDetail || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.anyOtherDetailRemarkProposedSite || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.siteInspecionAnyOtheDetailObservation || "N/A"}</td>
                  <td style={tableCell}>{inspectionDetails?.siteInspecionAnyOtheDetailRemarks || "N/A"}</td>
                </tr> */}
              </tbody>
            </table>
          </div>
          <div className="inspection-Card-Tb">
            <h2 className="inspection-Card-h1">Site Inspection Form</h2>
            {/* <Grid container spacing={2} style={{ display: 'flex' }}>
                            <Grid item xs={3} >
                                <p>Recommendation</p>
                            </Grid>
                            <Grid item xs={9} >
                                {inspectionDetails?.siteInspectionRecommendation || "N/A"}
                            </Grid>
                            {inspectionDetails?.inspectionReportData?.documentInspection?.map((doc, index) => (
                                <div className='row'>
                            <Grid item xs={3} >
                                <p>Doument </p>
                            </Grid>
                            <Grid item xs={9} >
                                
                                    <IconButton
                                        href={doc?.fileStoreUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        size="small"
                                        style={{ marginLeft: 8 }}
                                        title="Open Document"
                                    >
                                        <DescriptionIcon fontSize="small" />
                                    </IconButton>
                             
                            </Grid>
                            </div>
                              ) )}
                            <Grid item xs={3} >
                                <p>Remark</p>
                            </Grid>
                            <Grid item xs={9} >
                                {<div dangerouslySetInnerHTML={{ __html: inspectionDetails?.inspectionReportData?.developerRemarks }} />}
                            </Grid>
                        </Grid> */}
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <strong>Recommendation</strong>
                  </TableCell>
                  <TableCell>{inspectionDetails?.siteInspectionRecommendation || "N/A"}</TableCell>
                </TableRow>

                {inspectionDetails?.documentInspection?.map((doc, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <strong>Document</strong>
                    </TableCell>
                    <TableCell>
                      <IconButton href={doc?.fileStoreUrl} target="_blank" rel="noopener noreferrer" size="small" title="Open Document">
                        <DescriptionIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}

                <TableRow>
                  <TableCell>
                    <strong>Remark</strong>
                  </TableCell>
                  <TableCell>
                    <SafeHtml html={inspectionDetails?.developerRemarks || "N/A"} />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </div>
        {/* ))} */}
      </form>
    </div>
  );
};

const tableHeader = { padding: "10px", border: "1px solid #ccc", textAlign: "left", fontWeight: "bold" };
const tableCell = { padding: "10px", border: "1px solid #ccc" };

export default InspectionViewseer;
